import API from 'services/API';
import { createPropertyObject } from 'modules/App/utils/helpers';

export default function getPropertyObjects() {
  return API.request({
    method: 'GET',
    url: '/property/all',
    mapper: (data) => data.map(createPropertyObject).filter((object) => object),
  });
}
